import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Gamepad2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Team() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/team`).then(r => {
      setMembers(r.data || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <section id="team" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <h2 className="text-3xl lg:text-4xl font-semibold tracking-tight">Ekibimizle Tanışın</h2>
          <p className="mt-3" style={{ color: 'var(--text-muted)' }}>Discord'da yetkili rollere sahip ve yönetim ekibi tarafından özel olarak eklenen değerli üyelerimiz.</p>
        </div>

        {loading && (
          <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {Array.from({ length: 10 }).map((_, i) => (
              <div key={i} className="card-soft rounded-2xl p-5 h-52 animate-pulse" />
            ))}
          </div>
        )}

        {!loading && members.length > 0 && (
          <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {members.map(m => (
              <Link to={`/profil/${m.userId}`} key={m.userId} className="card-soft rounded-2xl p-5 flex flex-col items-center text-center hover:-translate-y-0.5 transition-transform duration-300">
                {m.avatar ? (
                  <img src={m.avatar} alt={m.username} className="w-20 h-20 rounded-2xl object-cover" style={{ background: 'var(--pill-hover)' }} />
                ) : (
                  <div className="w-20 h-20 rounded-2xl flex items-center justify-center" style={{ background: 'var(--pill-hover)' }}>
                    <Gamepad2 size={24} />
                  </div>
                )}
                <div className="mt-3 font-semibold">{m.displayName}</div>
                <div className="text-xs mt-0.5" style={{ color: 'var(--text-muted)' }}>@{m.username}</div>
                <div className="mt-2 text-[11px] font-semibold uppercase tracking-wider" style={{ color: 'var(--text-muted)' }}>{m.rankName}</div>
              </Link>
            ))}
          </div>
        )}

        {!loading && members.length === 0 && (
          <div className="mt-10 card-soft rounded-2xl p-10 text-center" style={{ color: 'var(--text-muted)' }}>
            Ekip bilgileri şu anda yüklenemedi.
          </div>
        )}
      </div>
    </section>
  );
}
